/**
 * Phase/beat-driven sound cues that don't belong to a specific widget:
 *   • a card "deal" sound when the round deals (DEALING),
 *   • a dice rattle when the tiebreak throws (tiebreakBeat → 'throw').
 *
 * The other cues live where the gesture happens: hit/stand in ActionBar, the
 * 3-2-1 in Countdown321 + the tiebreak countdown, the win jingle in Announcement.
 * Renders nothing.
 */

import { useEffect } from 'react';
import { useGameStore } from '../state/store';
import { playSfx } from '../audio/sfx';

export function SfxCues() {
  const phase = useGameStore((s) => s.server.phase);
  const beat = useGameStore((s) => s.tiebreakBeat);

  useEffect(() => {
    if (phase === 'DEALING') playSfx('cardDeal');
  }, [phase]);

  useEffect(() => {
    if (beat === 'throw') playSfx('diceRattle');
  }, [beat]);

  return null;
}
